import type ValorantProduct from "../../modules/valorant/types/ValorantProduct";
import VALORANT_API from "./valorantFetcher";

namespace ValorantService {
  export async function getAllProducts() {
    return VALORANT_API.get<ValorantProduct[]>("/products").then(
      (res) => res.data,
    );
  }
}

export default ValorantService;
